export default __webpack_public_path__ + "static/media/gam-stop-logo.1691c726.svg";